<mat-drawer-container class="h-full">
  <mat-drawer disableClose="true" mode="side" opened="true" class="pt-[25px]" [ngClass]="{ expanded: isExpanded() }">
    <mat-nav-list>
         <div class="flex w-full mb-4">
          <h1 *ngIf="isExpanded()" class="whitespace-nowrap w-full pl-4 font-medium text-[16px] text-[#372121]">Mi Backoffice</h1>
         <div class="flex w-full" [ngClass]="{ rotatedDivPrincipal: !isExpanded(), rotatedDiv: isExpanded() }">
            <button class="toggle-btn" [ngClass]="{ rotatedButton: isExpanded() }" (click)="toggleDrawer()">
              <span [ngClass]="{ rotated: isExpanded() }">
               <img width="16px" height="16px" src="../../../../assets/svg/Chevron.svg" alt="arrow">
              </span>
            </button>
          </div>
         </div>
       
      <mat-expansion-panel
        [disabled]="!isExpanded()"
        (closed)="panelOpenStateSearch.set(false)"
        (opened)="panelOpenStateSearch.set(true)"
        [(expanded)]="panelOpenStateSearch">
        <mat-expansion-panel-header (click)="onHeaderClick()">
          <mat-panel-title>
            <img alt="Buscar" width="26px" height="26px" class="mr-4" src="../../../../assets/svg/Search.svg" />
            <p class="text-sm whitespace-nowrap">Mis propiedades</p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ul>
          <li><button (click)="goTo(routes.PUBLICATIONS)">Mis publicaciones</button></li>
        </ul>
      </mat-expansion-panel>
      <mat-expansion-panel
        [disabled]="!isExpanded()"
        (closed)="panelOpenStateConfiguration.set(false)"
        (opened)="panelOpenStateConfiguration.set(true)"
        [(expanded)]="panelOpenStateConfiguration">
        <mat-expansion-panel-header (click)="onHeaderClick()">
          <mat-panel-title>
            <img
              alt="Configuración"
              width="26px"
              height="26px"
              class="mr-4"
              src="../../../../assets/svg/Configuración.svg" />
            <p class="text-sm whitespace-nowrap">Configuración</p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ul>
          <li><button (click)="goTo(routes.MY_DATA)">Mis datos</button></li>
          <br />
        </ul>
      </mat-expansion-panel>
      <mat-expansion-panel
        [disabled]="!isExpanded()"
        (closed)="panelOpenStateBooking.set(false)"
        (opened)="panelOpenStateBooking.set(true)"
        [(expanded)]="panelOpenStateBooking">
        <mat-expansion-panel-header (click)="onHeaderClick()">
          <mat-panel-title>
            <img
              alt="Reservas"
              width="26px"
              height="26px"
              class="mr-4"
              src="../../../../assets/svg/casa.svg" />
            <p class="text-sm whitespace-nowrap">Reservas</p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ul>
          <li><button (click)="goTo(routes.BOOKING)">Reservas</button></li>
          <br />
        </ul>
      </mat-expansion-panel>
    </mat-nav-list>
  </mat-drawer>
  <div class="pb-6 pl-8 pr-8 pt-[25px] h-full overflow-y-auto">
    <router-outlet></router-outlet>
  </div>
</mat-drawer-container>
